import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewClasificacionContable = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'clasificacion_contable',
        name: 'Clasificacion Contable',
        component: ViewClasificacionContable,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
